import axios, { AxiosResponse } from 'axios';
import useUser from './useUser';

import { URL_CROSSING_INVOICES } from 'constants/url';

export default function useCrossingInvoices() {
  const { jwt } = useUser();
  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getInvoices = async (dropshipper: string, endDate: Date, initialDate: Date) => {
    return await axios
      .get(
        `${URL_CROSSING_INVOICES}/get-invoices?initialDate=${initialDate}&endDate=${endDate}&dropshipper=${dropshipper}`,
        {
          headers
        }
      )
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  const getInvoicesByOc = async (oc: string) => {
    return await axios
      .get(`${URL_CROSSING_INVOICES}/get-invoices-oc?oc=${oc}`, {
        headers
      })
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  const uploadInvoices = async (formData: FormData) => {
    return await axios
      .post(`${URL_CROSSING_INVOICES}/upload`, formData, {
        headers
      })
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  const update = async (data: any) => {
    return await axios
      .put(`${URL_CROSSING_INVOICES}/update`, data, {
        headers
      })
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  return {
    getInvoices,
    uploadInvoices,
    getInvoicesByOc,
    update
  };
}
